module.exports = __webpack_public_path__ + "img/7605613.f6c9bb31.png";